import api from "./api";

export interface PromotionNotice {
  id: number;
  unused_days: number;
  sent_at: string | null;
  channels: Record<string, unknown> | null;
  read_at: string | null;
  response_due_date: string | null;
  employee_plan: string[] | null;
  replied_at: string | null;
  designated_dates: string[] | null;
  memo: string | null;
}

export interface MyPromotionNotice extends PromotionNotice {
  year: number;
  stage: number;
}

export interface PromotionTarget {
  user_id: string;
  user_name: string;
  email: string | null;
  hire_date: string | null;
  unused_days: number;
  stage1: PromotionNotice | null;
  stage2: PromotionNotice | null;
}

class LeavePromotionService {
  private base = "/leave-promotions";

  async targets(year?: number): Promise<{ year: number; targets: PromotionTarget[] }> {
    const r = await api.get(`${this.base}/targets`, { params: year ? { year } : undefined });
    return r.data;
  }
  async sendStage1(year: number, userIds: string[]): Promise<{
    sent: number; skipped: number; response_due_date: string; auto_completed: number;
  }> {
    const r = await api.post(`${this.base}/stage1`, { year, user_ids: userIds });
    return r.data;
  }
  async sendStage2(year: number, designations: { user_id: string; dates: string[]; memo?: string }[]):
    Promise<{ sent: number; skipped: number; errors: string[]; auto_completed: number }> {
    const r = await api.post(`${this.base}/stage2`, { year, designations });
    return r.data;
  }

  async myNotices(): Promise<MyPromotionNotice[]> {
    const r = await api.get(`${this.base}/my`);
    return r.data;
  }
  async acknowledge(id: number): Promise<void> {
    await api.post(`${this.base}/my/${id}/acknowledge`);
  }
  async reply(id: number, dates: string[]): Promise<void> {
    await api.post(`${this.base}/my/${id}/reply`, { dates });
  }
}

const leavePromotionService = new LeavePromotionService();
export default leavePromotionService;
